import { render, staticRenderFns } from "./SubpageDashboard.vue?vue&type=template&id=a4e48b26&scoped=true&"
import script from "./SubpageDashboard.vue?vue&type=script&lang=js&"
export * from "./SubpageDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4e48b26",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo-agent-home/xml-data/build-dir/WWW-WWW-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a4e48b26')) {
      api.createRecord('a4e48b26', component.options)
    } else {
      api.reload('a4e48b26', component.options)
    }
    module.hot.accept("./SubpageDashboard.vue?vue&type=template&id=a4e48b26&scoped=true&", function () {
      api.rerender('a4e48b26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/components/myaccount/accountdashboard/SubpageDashboard.vue"
export default component.exports